import styled from 'styled-components';

import { useStore } from 'models/Provider';

/** `isInline` follows the last card; an absolute bar anchors to the unscrolled box. */
export const LoadingMore = ({ isInline = false }) => {
  const { t } = useStore();
  return (
    <Loading $isInline={isInline}>
      <div>{t('job.stages.loadingMore')}</div>
    </Loading>
  );
};

const Loading = styled.div((p) => ({
  position: p.$isInline ? 'relative' : 'absolute',
  ...(p.$isInline ? {} : { bottom: 0, left: 0, right: 0 }),
  zIndex: 2,
  height: '2.5rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: p.theme.colors.white,
  backgroundColor: p.theme.colors.purple80,
  ...p.theme.text.bold16,
  borderRadius: '0 0 0.25rem 0.25rem',

  overflow: 'hidden',
  width: '100%',
}));
